<template>
  <div class="documentation">
    <Breadcumb title="Ajouter un document pédagogique" :breadcumb-data="breadcumbData"></Breadcumb>
      <b-form @submit="addDocument" class="cardcontainer" id="docform">
        <form-wizard class="form-wizard-boxed-steps">
          <!-- Allow html in tab title (this template required for the proper styling) -->
          <template slot="step" slot-scope="props">
            <wizard-step :tab="props.tab" @click.native="props.navigateToTab(props.index)" @keyup.enter.native="props.navigateToTab(props.index)" :transition="props.transition" :index="props.index">
              <span slot="title" :class="{'text-danger':props.tab.validationError}" v-html="props.tab.title"></span>
            </wizard-step>
          </template>
          <!-- / -->

          <tab-content title="<div class='small text-muted'>Etape 1</div>Paramètres généraux">
            <b-card class="mb-3">
              <b-form-group label="Catégorie" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-select value="Choisir une catégorie de document" v-model="category_id" :options="categoryData"/>
              </b-form-group>
              <b-form-group label="Vignette" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-file v-model="preview" ref="preview" />
              </b-form-group>
              <b-form-group label="Cible" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-check-group plain v-model="user_types" :options="userTypeData"/>
                <div v-if="errors['user_types']" class="invalid-tooltip">{{ errors['user_types'][0] }}</div>
              </b-form-group>
            </b-card>
          </tab-content>
          <tab-content title="<div class='small text-muted'>Etape 2</div>Français">
            <b-card class="mb-3">
              <b-form-group label="Nom en Français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-input type="text" placeholder="Label français" v-model="label" :state="errors.label ? 'invalid': ''"/>
                <div v-if="errors['label']" class="invalid-tooltip">{{ errors['label'][0] }}</div>
              </b-form-group>
              <b-form-group label="Description en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-textarea placeholder="Description en français" :rows="3" v-model="description"/>
              </b-form-group>
              <div :style="fileType === 'document' ? 'display: block' : 'display: none'">
                <b-form-group label="Document en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                  <b-file v-model="document" ref="document"/>
                </b-form-group>
              </div>
              <div :style="fileType === 'video' ? 'display: block' : 'display: none'">
                <b-form-group label="Lien vidéo en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                  <b-textarea placeholder="Video en français" :rows="3" v-model="video"/>
                </b-form-group>
              </div>
              <div :style="fileType === 'article' ? 'display: block' : 'display: none'">
                <b-form-group label="Article en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                  <b-textarea placeholder="Article" :rows="3" v-model="article"/>
                </b-form-group>
              </div>
            </b-card>
          </tab-content>
          <tab-content title="<div class='small text-muted'>Etape 3</div>Anglais">
            <b-card class="mb-3">
              <b-form-group label="Nom en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-input :required="false" type="text" placeholder="Label" v-model="label_en" :state="errors['label_en'] ? 'invalid': ''"/>
                <div v-if="errors['label_en']" class="invalid-tooltip">{{ errors['label_en'][0] }}</div>
              </b-form-group>
              <b-form-group label="Description en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-textarea placeholder="Description en anglais" :rows="3" v-model="description_en"/>
              </b-form-group>
              <div :style="fileType === 'document' ? 'display: block' : 'display: none'">
                <b-form-group label="Document en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                  <b-file v-model="document_en" ref="document_en"/>
                </b-form-group>
              </div>
              <div :style="fileType === 'article' ? 'display: block' : 'display: none'">
                <b-form-group label="Article en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                  <b-textarea placeholder="Article" :rows="3" v-model="article_en"/>
                </b-form-group>
              </div>
              <div :style="fileType === 'video' ? 'display: block' : 'display: none'">
                <b-form-group label="Lien vidéo en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                  <b-textarea placeholder="Video en anglais" :rows="3" v-model="video_en"/>
                </b-form-group>
              </div>
            </b-card>
          </tab-content>

          <!-- Buttons -->
          <b-btn variant="default" slot="prev">Retour</b-btn>
          <b-btn variant="default" slot="next">Suivant</b-btn>
          <b-btn variant="primary" slot="finish" @click="addDocument">Ajouter</b-btn>
        </form-wizard>
      </b-form>
  </div>
</template>
<style src="@/vendor/libs/vue-form-wizard/vue-form-wizard.scss" lang="scss"></style>
<script>
  import { ADMIN_ADD_DOCUMENT_REQUEST, ADMIN_GET_CATEGORIES_REQUEST } from '../../_store/administration/document/actiontypes';
  import { ADMIN_GET_USERTYPES_REQUEST} from '../../_store/administration/user/actiontypes'
  import { mapState } from 'vuex';
  import Breadcumb from '../../components/breadcumb';
  import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      if (file === undefined) {
        return resolve(null);
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      }
    });
  }

  export default {
    name: 'adminDocumentationAdd',
    components: { Breadcumb, FormWizard, TabContent, WizardStep },
    mounted() {
      this.fileType = this.$route.params.filetype;
      this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
        .then(response => {
          this.userTypeData = response.data.usertypes.map(userType => {
            return {
              value: userType.id,
              text: userType.label
            };
          });
        });
      this.$store.dispatch(ADMIN_GET_CATEGORIES_REQUEST)
        .then(response => {
          this.categoryData = response.data.categories.map(category => {
            return {
              value: category.id,
              text: category.label
            };
          });
        });
    },
    computed: mapState({ errors: state => state.admin_document.errors }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des documents pédagogiques', href: '/dashboard/administration/documentation/' },
          { text: 'Ajouter un document pédagogique', active: true },
        ],
        fileType: '',
        userTypeData: [],
        user_types: [],
        categoryData: [],
        category_id: 0,
        label_en: '',
        label: '',
        description_en: '',
        description: '',
        document_en: null,
        document: null,
        preview: null,
        video: '',
        video_en: '',
        article: '',
        article_en: ''
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      addDocument: function (e) {
        e.preventDefault();
        getBase64(this.$refs.document.$el.querySelector('input[type=file]').files[0])
          .then(documentB64 => {
            this.document = documentB64;
            return getBase64(this.$refs.document_en.$el.querySelector('input[type=file]').files[0]);
          })
          .then(documentFrB64 => {
            this.document_en = documentFrB64;
            return getBase64(this.$refs.preview.$el.querySelector('input[type=file]').files[0]);
          })
          .then(previewb64 => {
            this.preview = previewb64;
            this.$store.dispatch(ADMIN_ADD_DOCUMENT_REQUEST, {
              label_en: this.label_en,
              label: this.label,
              description_en: this.description_en,
              description: this.description,
              document_en: this.document_en,
              document: this.document,
              preview: this.preview,
              category: Number(this.category_id),
              user_types: this.user_types,
              video: this.video,
              video_en: this.video_en,
              article: this.article,
              article_en: this.article_en,
              filetype: this.fileType,
            })
              .then(() => {
                this.$router.push('/dashboard/administration/documentation/');
              })
              .catch((error) => {
                console.log('error is ==');
                console.log(error);
              });
          });
      }
    },
  };
</script>
